import { useParams } from "react-router-dom";
import AboutDoctor from "./AboutDoctor";
import AboutDoctorVishnu from "./AboutDoctorVishnu";

function DoctorProfile() {

  const { id } = useParams();

  if (id === "trupti") {
    return <AboutDoctor />;
  }

  if (id === "vishnu") {
    return <AboutDoctorVishnu />;
  }

}

export default DoctorProfile;